<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar style="display: inline-block;"></app-topbar>
    <div class="layout-sidebar" style="display: inline-block;">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
